module.exports = __webpack_public_path__ + "img/rincian-1.3b2a68ec.png";